export enum ESenderActionTypes {
  SenderValue = 'SENDER_VALUE',
  SenderOnChange = 'SENDER_ONCHANGE',
  SenderOnClear = 'SENDER_ONCLEAR',
  SenderTypeValue = 'SENDER_TYPE_VALUE',
  SenderAsset = 'SENDER_ASSET',
  SenderAccountData = 'SENDER_ACCOUNT_DATA',
  SenderAccountValue = 'SENDER_ACCOUNT_VALUE',
  SelectSenderAccountData = 'SELECT_SENDER_ACCOUNT_DATA',
  SelectSenderAccountDataOnClear = 'SELECT_SENDER_ACCOUNT_DATA_ONCLEAR',
  SearchSenderValue = 'SEARCH_SENDER_VALUE',
  SenderCounterpartyValue = 'SENDER_COUNTERPARTY_VALUE',
  SenderCounterpartyOnClear = 'SENDER_COUNTERPARTY_ONCLEAR',
  SenderCounterpartyOnChange = 'SENDER_COUNTERPARTY_ONCHANGE',
  SenderTypeOnChange = 'SENDER_TYPE_ONCHANGE',
  SenderDetailAccountsOnChange = 'SENDER_DETAIL_ACCOUNTS_ONCHANGE',
  SenderCustomerSelect = 'SENDER_CUSTOMER_SELECT',
  SenderBalanceVisible = 'SENDER_BALANCE_VISIBLE',
  SearchSenderCounterpartyValue = 'SEARCH_SENDER_COUNTERPARTY_VALUE',
  SearchSenderAccountValue = 'SEARCH_SENDER_ACCOUNT_VALUE',
  SwapAccounts = 'SWAP_ACCOUNTS',
  Swap = 'SWAP',
}

export enum ERecipientActionTypes {
  RecipientValue = 'RECIPIENT_VALUE',
  RecipientOnChange = 'RECIPIENT_ONCHANGE',
  RecipientOnClear = 'RECIPIENT_ONCLEAR',
  RecipientTypeValue = 'RECIPIENT_TYPE_VALUE',
  RecipientAsset = 'RECIPIENT_ASSET',
  RecipientAccountData = 'RECIPIENT_ACCOUNT_DATA',
  RecipientAccountValue = 'RECIPIENT_ACCOUNT_VALUE',
  SelectRecipientAccountData = 'SELECT_RECIPIENT_ACCOUNT_DATA',
  SelectRecipientAccountDataOnClear = 'SELECT_RECIPIENT_ACCOUNT_DATA_ONCLEAR',
  SearchRecipientValue = 'SEARCH_RECIPIENT_VALUE',
  SearchRecipientAccountValue = 'SEARCH_RECIPIENT_ACCOUNT_VALUE',
  RecipientCounterpartyValue = 'RECIPIENT_COUNTERPARTY_VALUE',
  RecipientCounterpartyOnClear = 'RECIPIENT_COUNTERPARTY_ONCLEAR',
  RecipientCounterpartyOnChange = 'RECIPIENT_COUNTERPARTY_ONCHANGE',
  RecipientTypeOnChange = 'RECIPIENT_TYPE_ONCHANGE',
  RecipientDetailAccountsOnChange = 'RECIPIENT_DETAIL_ACCOUNTS_ONCHANGE',
  RecipientDetailAccountsOnClear = 'RECIPIENT_DETAIL_ACCOUNTS_ONCLEAR',
  RecipientCustomerSelect = 'RECIPIENT_CUSTOMER_SELECT',
  SwapAccounts = 'SWAP_ACCOUNTS',
  Swap = 'SWAP',
}

export enum EPaymentsFormItemName {
  SenderCounterparty = 'sender_counterparty',
  SenderType = 'sender_type',
  SenderValue = 'sender_value',
  SenderDetailAccounts = 'sender_detail_accounts',
  RecipientCounterparty = 'recipient_counterparty',
  RecipientType = 'recipient_type',
  RecipientValue = 'recipient_value',
  RecipientDetailAccounts = 'recipient_detail_accounts',
  Amount = 'amount_value',
  Schedule = 'schedule',
}
